import FullCC from "./Full";
import TokenizedCC from "./Tokenized";

interface CCProps {
  className?: string;
  cvv?: string;
  fieldPrefix?: string;
  hideCvv?: boolean;
  tokenizedCard?: be.TokenizedCreditCard;
}

function CreditCard({
  className = "",
  cvv,
  fieldPrefix = "",
  hideCvv,
  tokenizedCard,
}: CCProps): JSX.Element {
  const tempToken = tokenizedCard?.token && tokenizedCard?.tokenType == "temp";

  let cc;
  if (!tokenizedCard?.token || tempToken) {
    cc = (
      <FullCC
        className={className}
        cvv={cvv}
        fieldPrefix={fieldPrefix}
        hideCvv={hideCvv}
        tokenizedCard={tokenizedCard}
      />
    );
  } else {
    cc = <TokenizedCC className={className} tokenizedCard={tokenizedCard} />;
  }

  return cc;
}

export default CreditCard;
